export const EFFECT = Symbol('EFFECT');
